export const searchableDropdownRoot = {
    borderColor: 'var(--tl-color-border)',
    borderRadius: 'var(--tl-radius)',
    hoverBorderColor: 'var(--tl-color-border)',
    focusBorderColor: 'var(--tl-color-border)',
    placeholderColor: 'var(--tl-color-muted-foreground)',
    invalidPlaceholderColor: 'var(--tl-color-muted-foreground)',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'var(--tl-focus-ring)',
    },
    paddingX: 'var(--tl-padding-3)',
    paddingY: 'calc(var(--tl-padding-2) + 1px)',
    shadow: 'none',
}

export const searchableDropdownOverlay = {
    background: 'var(--tl-color-popover)',
    borderColor: 'var(--tl-color-border)',
    borderRadius: 'var(--tl-radius-md)',
    color: 'var(--tl-color-popover-foreground)',
    shadow: '0 2px 4px -2px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1)',
}

export const searchableDropdownList = {
    padding: 'var(--tl-padding-1)',
    gap: '0',
    header: {
        padding: 'var(--tl-padding-2)',
    },
}

export const searchableDropdownOption = {
    focusBackground: 'var(--tl-color-accent)',
    selectedBackground: 'var(--tl-color-accent)',
    selectedFocusBackground: 'var(--tl-color-accent)',
    color: 'var(--tl-color-foreground)',
    focusColor: 'var(--tl-color-foreground)',
    selectedColor: 'var(--tl-color-foreground)',
    selectedFocusColor: 'var(--tl-color-foreground)',
    padding: 'var(--tl-padding-1-5) var(--tl-padding-2)',
    borderRadius: 'var(--tl-radius-sm)',
}

export const searchableDropdownEmptyMessage = {
    padding: 'var(--tl-padding-1-5) var(--tl-padding-2)',
}

export const searchableDropdownChip = {
    borderRadius: 'var(--tl-radius-sm)',
}
